import type { Recipe } from './shopping';

export const SAMPLE_RECIPES: Recipe[] = [
  {
    id: 'r001', name: 'Classic Chicken Stir-Fry', description: 'Quick weeknight stir-fry with vegetables',
    servings: 4, prepTime: 15, cookTime: 15,
    ingredients: [
      { name: 'chicken breast', quantity: 1.5, unit: 'lb', category: 'meat' },
      { name: 'broccoli', quantity: 2, unit: 'cup', category: 'produce' },
      { name: 'bell pepper', quantity: 2, unit: '', category: 'produce' },
      { name: 'soy sauce', quantity: 3, unit: 'tbsp', category: 'condiments' },
      { name: 'garlic', quantity: 3, unit: '', category: 'produce' },
      { name: 'ginger', quantity: 1, unit: 'tbsp', category: 'produce' },
      { name: 'rice', quantity: 2, unit: 'cup', category: 'grains' },
      { name: 'sesame oil', quantity: 1, unit: 'tbsp', category: 'condiments' },
    ],
    instructions: ['Cook rice per package directions.', 'Slice chicken into strips, season.', 'Stir-fry chicken 5-6 min until cooked.', 'Add vegetables, cook 3-4 min.', 'Add sauce, toss, serve over rice.'],
    dietaryTags: ['gluten-free'], createdAt: new Date().toISOString(),
  },
  {
    id: 'r002', name: 'Veggie Pasta Primavera', description: 'Colorful vegetable pasta with garlic and parmesan',
    servings: 4, prepTime: 10, cookTime: 20,
    ingredients: [
      { name: 'penne pasta', quantity: 1, unit: 'lb', category: 'grains' },
      { name: 'zucchini', quantity: 2, unit: '', category: 'produce' },
      { name: 'cherry tomatoes', quantity: 1, unit: 'cup', category: 'produce' },
      { name: 'bell pepper', quantity: 1, unit: '', category: 'produce' },
      { name: 'garlic', quantity: 4, unit: '', category: 'produce' },
      { name: 'olive oil', quantity: 3, unit: 'tbsp', category: 'condiments' },
      { name: 'parmesan cheese', quantity: 0.5, unit: 'cup', category: 'dairy' },
      { name: 'basil', quantity: 0.25, unit: 'cup', category: 'produce' },
    ],
    instructions: ['Boil pasta until al dente.', 'Sauté garlic in olive oil.', 'Add vegetables, cook 5 min.', 'Toss with pasta, top with parmesan and basil.'],
    dietaryTags: ['vegetarian'], createdAt: new Date().toISOString(),
  },
  {
    id: 'r003', name: 'Black Bean Tacos', description: 'Simple and satisfying vegetarian tacos',
    servings: 4, prepTime: 10, cookTime: 10,
    ingredients: [
      { name: 'black beans', quantity: 2, unit: 'can', category: 'canned' },
      { name: 'corn tortillas', quantity: 12, unit: '', category: 'bakery' },
      { name: 'avocado', quantity: 2, unit: '', category: 'produce' },
      { name: 'tomato', quantity: 2, unit: '', category: 'produce' },
      { name: 'onion', quantity: 1, unit: '', category: 'produce' },
      { name: 'cilantro', quantity: 1, unit: 'bunch', category: 'produce' },
      { name: 'lime', quantity: 2, unit: '', category: 'produce' },
      { name: 'cumin', quantity: 1, unit: 'tsp', category: 'condiments' },
      { name: 'salsa', quantity: 1, unit: 'cup', category: 'condiments' },
    ],
    instructions: ['Heat beans with cumin.', 'Warm tortillas.', 'Dice avocado, tomato, onion.', 'Assemble tacos, top with salsa, cilantro, lime.'],
    dietaryTags: ['vegan', 'vegetarian', 'gluten-free'], createdAt: new Date().toISOString(),
  },
  {
    id: 'r004', name: 'Salmon & Roasted Vegetables', description: 'Sheet pan salmon with seasonal vegetables',
    servings: 4, prepTime: 10, cookTime: 25,
    ingredients: [
      { name: 'salmon fillet', quantity: 1.5, unit: 'lb', category: 'meat' },
      { name: 'broccoli', quantity: 2, unit: 'cup', category: 'produce' },
      { name: 'sweet potato', quantity: 2, unit: '', category: 'produce' },
      { name: 'olive oil', quantity: 2, unit: 'tbsp', category: 'condiments' },
      { name: 'lemon', quantity: 1, unit: '', category: 'produce' },
      { name: 'garlic', quantity: 3, unit: '', category: 'produce' },
    ],
    instructions: ['Preheat oven to 400°F.', 'Cube sweet potato, toss with oil.', 'Roast 10 min, add broccoli and salmon.', 'Season, roast 15 min more.', 'Squeeze lemon over everything.'],
    dietaryTags: ['keto', 'paleo', 'gluten-free', 'pescatarian'], createdAt: new Date().toISOString(),
  },
  {
    id: 'r005', name: 'Overnight Oats', description: 'No-cook breakfast ready when you wake up',
    servings: 2, prepTime: 5, cookTime: 0,
    ingredients: [
      { name: 'rolled oats', quantity: 1, unit: 'cup', category: 'grains' },
      { name: 'milk', quantity: 1, unit: 'cup', category: 'dairy' },
      { name: 'yogurt', quantity: 0.5, unit: 'cup', category: 'dairy' },
      { name: 'honey', quantity: 2, unit: 'tbsp', category: 'condiments' },
      { name: 'blueberries', quantity: 0.5, unit: 'cup', category: 'produce' },
      { name: 'banana', quantity: 1, unit: '', category: 'produce' },
    ],
    instructions: ['Mix oats, milk, yogurt, honey in jar.', 'Refrigerate overnight.', 'Top with fruit in the morning.'],
    dietaryTags: ['vegetarian'], createdAt: new Date().toISOString(),
  },
  {
    id: 'r006', name: 'Turkey Chili', description: 'Hearty one-pot chili for meal prep',
    servings: 6, prepTime: 15, cookTime: 45,
    ingredients: [
      { name: 'ground turkey', quantity: 2, unit: 'lb', category: 'meat' },
      { name: 'kidney beans', quantity: 2, unit: 'can', category: 'canned' },
      { name: 'diced tomatoes', quantity: 2, unit: 'can', category: 'canned' },
      { name: 'onion', quantity: 1, unit: '', category: 'produce' },
      { name: 'bell pepper', quantity: 2, unit: '', category: 'produce' },
      { name: 'garlic', quantity: 4, unit: '', category: 'produce' },
      { name: 'chili powder', quantity: 2, unit: 'tbsp', category: 'condiments' },
      { name: 'cumin', quantity: 1, unit: 'tbsp', category: 'condiments' },
    ],
    instructions: ['Brown turkey with onion and garlic.', 'Add peppers, cook 3 min.', 'Add beans, tomatoes, spices.', 'Simmer 40 min.', 'Season to taste.'],
    dietaryTags: ['gluten-free'], createdAt: new Date().toISOString(),
  },
];
